export default "__VITE_ASSET__CF5MRWOl__"